import * as Yup from 'yup';

export const validationSchema = Yup.object({
  openDate: Yup.date()
    .transform((curr, orig) => (orig === '' ? null : curr))
    .test({
      message: 'It must be earlier than open date',
      test: (val, ctx) => {
        const { closeDate } = ctx.parent;
        if (closeDate !== null && val) {
          return new Date(val) < new Date(closeDate);
        }
        return true;
      },
    })
    .nullable()
    .required('Required'),
  closeDate: Yup.date()
    .transform((curr, orig) => (orig === '' ? null : curr))
    .test({
      message: 'It must be later than close date',
      test: (val, ctx) => {
        const { openDate } = ctx.parent;
        if (openDate !== null && val) {
          return new Date(val) > new Date(openDate);
        }
        return true;
      },
    })
    .nullable()
    .required('Required'),
  invoiceApproverId: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  })
    .required('Invoice Approver is required')
    .nullable(),
  documentApproverId: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  })
    .required('Document Approver is required')
    .nullable(),
  documentViewers: Yup.array(),
});
